import React from 'react';
import styled from 'styled-components';
import { TextLink, white } from '@spotify-internal/encore-creator-web';

import { MAIN_CONTENT_ID } from './Body';

// The purpose of a skip link is to allow keyboard-only users a way to quickly move from the start of the page to the main content,
// thus bypassing the top nav, or any other content before the main content.
// The skip link can be visually hidden until it receives focus, so it will not become visible unless it is focused via the keyboard.

const StyledLink = styled(TextLink)`
  color: ${white};
  padding: 25px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99999;

  &:not(:focus) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const SkipLink = () => {
  return (
    <StyledLink href={`#${MAIN_CONTENT_ID}`}>
      Skip to main page content
    </StyledLink>
  );
};
